export enum ClientType {
  Dealer = 'dealer',
  Supplier = 'supplier',
}
